export const jobTypes = [
  "Full Time",
  "Contract",
  "Internship",
  "Temporary",
  "Part-Time",
];
